import { createElement } from "@/utils/create-elem.js";

import { makeTips } from "@/core/makeTips.js";
import "@/styles/components/board.scss";
import { appState } from "@/utils/state.js";

export function tips(parent) {
  const matrix = appState.getState("matrix");

  const { rowTips, colTips } = makeTips(matrix);

  const verTips = createElement({
    tag: "div",
    classes: ["ver-tips", "board__item"],
    parent: parent,
  });

  const horTips = createElement({
    tag: "div",
    classes: ["hor-tips", "board__item"],

    parent: parent,
  });

  colTips.forEach((elem) => {
    const colTipElem = createElement({
      tag: "div",
      classes: ["tip-col"],
      parent: verTips,
    });
    elem.forEach((num) => {
      createElement({
        tag: "span",
        classes: ["tip"],
        text: num,
        parent: colTipElem,
      });
    });
  });

  rowTips.forEach((elem) => {
    const rowTipElem = createElement({
      tag: "div",
      classes: ["tip-row"],
      parent: horTips,
    });
    elem.forEach((num) => {
      createElement({
        tag: "span",
        classes: ["tip"],
        text: num,
        parent: rowTipElem,
      });
    });
  });
}
